import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IS1InputSelectItem } from '@app/s1';
import { CheckType } from '@app/shared/models/models';
import { CommessaService, ISearchAnnoCommessaParams } from '@app/shared/services/commessa.service';

@Component({
    selector: 'mdm-input-anno-commessa-select',
    templateUrl: './input-anno-commessa-select.component.html',
    styleUrl: './input-anno-commessa-select.component.scss',
    standalone: false
})
export class InputAnnoCommessaSelectComponent {

  @Input() options: Array<IS1InputSelectItem>;
  @Input() label: string;
  @Input() control: UntypedFormControl;
  @Input() bindAllObject: boolean = true;
  @Input() readonly: boolean = false;
  @Input() type: CheckType;

  @Input() set ente(newValue: string[]) {
    this._ente = newValue;
    this.search();
  }

  @Output() onSelectClear = new EventEmitter();
  @Output() onSelectChange = new EventEmitter();

  _anno: string;
  _ente: string[];

  constructor(private commessaService: CommessaService) { }
  
  ngAfterViewInit(): void {
    this.search();
  }

  ngOnInit(): void {}
  
  cleared() {
    this.onSelectClear.emit();
  }

  changed(event) {
    this.onSelectChange.emit(event);
  }

  setAnnoAndSearch(text?: string) {
    this._anno = text;
    this.search();
  }

  search() {

    if (this._anno?.length < 3 || this.type == null) {
      this.options = [];
      return;
    }

    const params: ISearchAnnoCommessaParams = {
      paging: true,
      page: 1,
      rows: 30,
      ente: this._ente,
      anno: this._anno ? Number(this._anno) : null
    }

    this.commessaService.getAnni(params, this.type).subscribe(options => {

      this.options = options.map(option => {

        return {
          code: option.code,
          label: option.label
        } as IS1InputSelectItem

      })

    })

  }

}
